<template>
  <a
    class="
      layout/inline-flex
      link/focus:children
    "
    :class="{'$color/reverse': reverseBg, '$color/background:black': !reverseBg}"
    :href="url"
    :data-gtm="gtm"
    data-moma-link="button"
    v-on:focus="$emit('onButtonLinkFocus')"
    >
    <span 
      class="
        link/focus
      "
      >
      <span
        class="
          $typography/baseline:solid
          $typography/size:large
          color/background
          layout/height:baseline:2
        "
        >
        <span
          class="
            $typography/size:medium
            layout/align:center
            layout/flex
            layout/height:100%
            layout/padding:cap
          "
          >
          <span
            class="
              $typography/weight:bold
              typography
              typography/nowrap
            "
            :class="{textColor: !reverseBg}"
            v-html="text"
          />
        </span>
      </span>
    </span>
  </a>
</template>

<script>
  export default {
    props: {
      url: {type: String, required: true},
      text: {type: String, required: true},
      gtm: {type: String, required: false, default: null},
      reverseBg: {type: Boolean, default: true},
      textColor: {type: String, required: false, default: null},
    }
  };
</script>
